// Intro background module
let _this = (module.exports = {
	// DOM elements
	dom: {
		body: document.body,
		sectionIntro: document.querySelector('.section-intro'),
	},

	// Variables
	vars: {
		animationDelay: 1500, // kada krece animacija
		finishDelay: 2300, // kada se zavrsava intro
	},

	intro: function () {
		const storage = localStorage.getItem('intro');

		if (!storage) {
			this.dom.body.classList.add('disable-scroll');

			setTimeout(() => {
				this.dom.body.classList.add('intro-animation');
			}, this.vars.animationDelay);

			setTimeout(() => {
				this.dom.body.classList.remove('disable-scroll');
				this.dom.body.classList.remove('intro-animation');
				this.dom.body.classList.add('enable-scroll');
				this.dom.sectionIntro.style.display = 'none';

				localStorage.setItem('intro', 'true');
			}, this.vars.finishDelay);
		} else {
			if (this.dom.sectionIntro) {
				this.dom.sectionIntro.style.display = 'none';
			}
		}
	},

	/**
	 * Init
	 */
	init: function () {
		this.intro();

		window.addEventListener('beforeunload', () => {
			sessionStorage.setItem('reload', 'true');
		});
	},
});
